import Request from "../../services/Request";
import ResponseChecker from "../../services/ResponseChecker";
import NotiMessage from "../../services/NotiMessage";
import apiClient from "../../services/Http";

const notiMessage = new NotiMessage("success");
//URL List
const eachDataUrl = "presumptive/ci/getEach?";
const allDataUrl = "presumptive/ci/get?";
const storeUrl = "presumptive/ci/store";
const updateUrl = "presumptive/ci/update";
const deleteUrl = "presumptive/ci/delete";

const getDefaultState = () => {
  return {
    ciEachData: {},
  };
};

const state = {
  ciData: [],
  ciEachData: {},
};
const getters = {};
const mutations = {
  SET_CI_DATA(state, payload) {
    state.ciData = payload.data.data;
  },
  SET_HE_EACH(state, payload) {
    state.ciEachData = payload.data.data;
  },
  Set_Township_Volunteers(state, payload) {
    state.townshipVolunteers = payload;
  },
  ADD_CI_DATA(state, payload) {
    state.ciData.push(payload.data.data);
  },
  REMOVE_HE_DATA(state, payload) {
    const ciData = state.ciData.filter((item) => item.id != payload.id);
    state.ciData = [...ciData];
  },
  resetState(state) {
    Object.assign(state, getDefaultState());
  },
};

const actions = {
  async getAll({ commit }, payload) {
    const response = await Request.get_data(allDataUrl, payload);
    const responseChecker = new ResponseChecker(response);
    responseChecker.checkResponse();
    if (responseChecker.isResponseStatusSuccess())
      commit("SET_CI_DATA", response);
  },
  async getEach({ commit }, id) {
    commit("resetState");
    const response = await Request.get_data(eachDataUrl, {
      column: "id",
      value: id,
    });
    const responseChecker = new ResponseChecker(response);
    responseChecker.checkResponse();
    if (responseChecker.isResponseStatusSuccess())
      commit("SET_HE_EACH", response);
  },
  async create({ commit }, payload) {
    const response = await Request.post_data(storeUrl, payload);
    const responseChecker = new ResponseChecker(response);
    responseChecker.checkResponse();
    if (responseChecker.isResponseStatusSuccess()) {
      commit("ADD_CI_DATA", response);
      notiMessage.displayNotiMsg("Saved Success");
      return true;
    }
    return false;
  },

  async update(context, payload) {
    const response = await Request.post_data(updateUrl, payload);
    const responseChecker = new ResponseChecker(response);
    responseChecker.checkResponse();
    if (responseChecker.isResponseStatusSuccess()) {
      notiMessage.displayNotiMsg("Updated Success");
      return true;
    }
    return false;
  },
  async delete({ commit }, payload) {
    const response = await Request.post_data(deleteUrl, payload);
    const responseChecker = new ResponseChecker(response);
    responseChecker.checkResponse();
    if (responseChecker.isResponseStatusSuccess()) {
      commit("REMOVE_HE_DATA", payload);
      notiMessage.displayNotiMsg("Deleted Success");
      return true;
    }

    return false;
  },
  
  async getExport(context, payload) {
    let url = `https://api.mdr.tbtheunion.com/api/ci/export?`;
    if (payload) {
        Object.keys(payload).forEach((key) => {
            url += `&${key}=${payload[key]}`;
        });
    }
    await apiClient
        .get(
            url, {
                responseType: "blob",
            }
        )
        .then(() => {
            window.location = url;
        });
},
};


export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
